<template>
  <d-row>
    <d-col cols="12" lg="9">
      <d-card class="card-small mb-4">
        <d-card-header class="border-bottom">
          <h6 class="m-0">Loop</h6>
        </d-card-header>
        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <puzzle-loop-form ref="puzzleLoopForm" />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <d-col cols="12" lg="3">
      <sidebar-actions
        :model.sync="puzzleLoop"
        @save="save"
        @generate="generate"
      />
    </d-col>
  </d-row>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import PuzzleLoopForm from './PuzzleLoopForm.vue';
import SidebarActions from './SidebarActions.vue';
import { _LOAD_PUZZLE_LOOP_MODEL_, MODEL } from './PuzzleLoopModel';


export default {
  name: 'puzzle-loop-page',
  components: {
    PuzzleLoopForm,
    SidebarActions,
  },
  computed: {
    puzzleLoop() {
      const { puzzleLoop } = this.$store.state.loop;
      if (puzzleLoop) {
        Events.$emit(_LOAD_PUZZLE_LOOP_MODEL_, puzzleLoop);
        return puzzleLoop;
      }
      return cloneDeep(MODEL);
    },
  },
  methods: {
    generate() {
      this.$refs.puzzleLoopForm.generate();
    },
    save() {
      this.$refs.puzzleLoopForm.save();
    },
  },
};
</script>
